import Const from 'constants';
import Action from 'actions';

let TeamNameStacking = {
    setTeamOptions(data) {
        return (dispatch) => {
            dispatch({
                type: Const.TEAM_NAME_STACKING_SET_TEAM_OPTIONS,
                data,
            });
            dispatch(this.saveTeamNameStackingToStorage());
        };
    },

    setAllTeamOptionsEnabledStatus(isEnabled) {
        return (dispatch) => {
            dispatch({
                type: Const.TEAM_NAME_STACKING_SET_ALL_TEAM_OPTIONS_ENABLED_STATUS,
                isEnabled,
            });
            dispatch(this.saveTeamNameStackingToStorage());
        };
    },

    setMaxPlayersForTeams(maxPlayersForTeams, teamNames) {
        return (dispatch) => {
            dispatch({
                type: Const.TEAM_NAME_STACKING_SET_MAX_PLAYERS_FOR_TEAMS,
                maxPlayersForTeams,
                teamNames,
            });
            dispatch(this.saveTeamNameStackingToStorage());
        };
    },

    setTeamNameStackingFromStorage(data) {
        return {
            type: Const.TEAM_NAME_STACKING_SET_DATA_FROM_STORAGE,
            data,
        };
    },

    useTeamNameStacking(use) {
        return {
            type: Const.TEAM_NAME_STACKING_SET_IS_USED,
            use,
        };
    },

    setTeamNameStackingWidgetIsHidden(hidden) {
        return {
            type: Const.TEAM_NAME_STACKING_SET_IS_WIDGET_HIDDEN,
            hidden,
        };
    },

    saveTeamNameStackingToStorage() {
        return (dispatch) => {
            dispatch(
                this.saveDataToStorage('teamNameStacking', function (state) {
                    const {teamNameStacking} = state;
                    return teamNameStacking.all();
                }),
            );
        };
    },
};

export default Object.assign(Action, TeamNameStacking);
